import { create } from "zustand";

export const useCommonStore = create(set => ({
	isLoading: [],
	setIsLoading: isLoading => set({ isLoading })
}));
